import {$http, $get} from './index';

export const customFormService = {
  getCustomForm(info, cn) {
    const path = 'api/customform/get';
    $get(`${info.tenantId}/customform/${info.customFormId}`).then(res => {
      cn(res);
    }, () => {
      $http(path, info).then(res => {
        cn(res);
      });
    });
  },

  action(info, cn) {
    const path = 'customForm/action';
    $http(path, info).then(res => {
      cn(res);
    });
  }
};